<template>
  <div class="form-group" v-bind:class="{ 'has-error': error }">
    <label v-if="label" :for="name" class="text-info">{{ label }}</label>
    <select type="text" @change="updateValue($event.target.value)" :name="name" :required="required" class="form-control">
      <option v-if="placeholder" value="">{{ placeholder }}</option>
      <option v-for="b in brands" :value="b.id" :selected="value == b.id">{{ b.name }}</option>
    </select>
    <span v-if="error" class="help-block" v-html="error"></span>
  </div>
</template>

<script>
  export default{
    name: 'InputBrands',
    props: ['name', 'value', 'brand', 'required', 'label', 'placeholder', 'error'],
    data () {
      return {
        brands: []
      }
    },
    mounted () {
      this.getBrands()
    },
    methods: {
      updateValue (value) {
        this.$emit('input', value)
      },
      getBrands () {
        this.$http.get('brands')
          .then(response => {
            this.brands = response.data
          }, () => false)
      }
    }
  }
</script>


// WEBPACK FOOTER //
// InputBrands.vue?9af3feec